import { useTranslations } from 'next-intl';

interface CancelOverlayProps {
  isVisible: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  onExit: () => void;
}

const CancelOverlay = ({
  isVisible,
  onCancel,
  onSubmit,
  onExit,
}: CancelOverlayProps) => {
  const t = useTranslations();

  return (
    <section
      id="js-canceloverlay-toggle"
      className={`CancelOverlay${isVisible ? ' is-visible' : ''}`}
    >
      <div className="CancelOverlay-content">
        <h1 className="CancelOverlay-title">{t('DRWNG__OVERLAY_TITLE')}</h1>
        <p className="CancelOverlay-text">{t('DRWNG__OVERLAY_TEXT')}</p>
        <button
          onClick={onCancel}
          className="CancelOverlay-closeButton"
          aria-label={t('DRWNG__A11Y_CLOSE')}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            version="1.1"
          >
            <path
              d="m11 0 1 1-5 5 5 5-1 1-5-5-5 5-1-1 5-5-5-5 1-1 5 5z"
              fill="currentColor"
            />
          </svg>
        </button>
        <div className="CancelOverlay_buttons">
          <button className="CancelOverlay-button" onClick={onExit}>
            <span className="CancelOverlay-buttonLabel">
              {t('DRWNG__OVERLAY_BTN_BACK')}
            </span>
            <span className="CancelOverlay-buttonIcon" />
          </button>
          <button
            className="CancelOverlay-button CancelOverlay-button--primary"
            onClick={onSubmit}
          >
            <span className="CancelOverlay-buttonLabel">
              {t('DRWNG__OVERLAY_BTN_SAVE')}
            </span>
            <span className="CancelOverlay-buttonIcon" />
          </button>
        </div>
      </div>

      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- click-to-dismiss backdrop; the same cancel action is reachable from the keyboard via the × button above, so this stays a pointer-only convenience rather than a redundant focusable element */}
      <div className="CancelOverlay-background" onClick={onCancel} />
    </section>
  );
};

export default CancelOverlay;
